// material-ui
import { useTheme } from "@mui/material/styles";

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <>
      <svg
        width="118"
        height="35"
        viewBox="0 0 118 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 5H13C20 5 25 10 25 17.5C25 25 20 30 13 30H5V5Z"
          fill={theme.vars.palette.primary.main}
        />
        <path
          d="M9 10H13C17 10 20 13 20 17.5C20 22 17 25 13 25H9V10Z"
          fill="white"
        />

        <text
          x="35"
          y="24"
          fontFamily="sans-serif"
          fontWeight="600"
          fontSize="18"
          fill="#000"
        >
          Dumora
        </text>
      </svg>
    </>
  );
}
